import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row, Card, CardBody, Button } from "reactstrap";
import { Fn_AddEditData, Fn_DisplayData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { Save, ArrowLeft } from "react-feather";

const AddEdit_StateMaster = () => {
  const API_URL_SAVE = "StateMaster/0/token";
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/StateMaster/Id";

  const [state, setState] = useState({ id: 0, formData: { Name: "", StateCode: "" } });
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const nameRef = useRef(null);

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  useEffect(() => { if (nameRef.current) nameRef.current.focus(); }, []);

  const validationSchema = Yup.object({
    Name: Yup.string().required("State name is required").min(2, "Min 2 characters"),
    StateCode: Yup.string().required("State code is required").min(2).max(10),
  });

  const handleSubmit = async (values) => {
    const obj = JSON.parse(localStorage.getItem("user"));
    let formData = new FormData();
    formData.append("Name", values.Name || "");
    formData.append("StateCode", values.StateCode || "");
    formData.append("UserId", obj == null || obj === undefined ? 0 : obj.uid);
    Fn_AddEditData(dispatch, setState, { arguList: { id: state.id, formData } }, API_URL_SAVE, true, "memberid", navigate, "/StateMaster");
  };

  return (
    <div style={{ padding: "6px 8px", maxWidth: 900, margin: "0 auto" }}>
      <Card className="border shadow-none" style={{ marginBottom: 0 }}>
        <CardBody className="p-2" style={{ padding: "8px 12px !important" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6, paddingBottom: 4, borderBottom: "1px solid #dee2e6" }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>State Master</span>
            <div style={{ display: "flex", gap: 6 }}>
              <Button type="button" size="sm" color="light" className="py-1 px-2" style={{ fontSize: 12 }} onClick={() => navigate("/StateMaster")}><ArrowLeft size={12} className="me-1" />Back</Button>
              <Button type="submit" form="state-form" size="sm" color="primary" className="py-1 px-2" style={{ fontSize: 12 }}><Save size={12} className="me-1" />Save</Button>
            </div>
          </div>
          <Formik initialValues={{ Name: state.formData.Name || "", StateCode: state.formData.StateCode || "" }} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize={true}>
            {({ errors, touched }) => (
              <Form id="state-form" style={{ marginTop: 4 }}>
                <Row style={{ gap: "0 8px", rowGap: 2 }}>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Name <span className="text-danger">*</span></label>
                    <Field innerRef={nameRef} className={`form-control form-control-sm ${errors.Name && touched.Name ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="text" name="Name" placeholder="Name" />
                    <ErrorMessage name="Name" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Code <span className="text-danger">*</span></label>
                    <Field className={`form-control form-control-sm ${errors.StateCode && touched.StateCode ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12, textTransform: "uppercase" }} type="text" name="StateCode" placeholder="e.g. MH" />
                    <ErrorMessage name="StateCode" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </div>
  );
};

export default AddEdit_StateMaster;
